
export type GetMessagesParams = {
page?: number;
size?: number;
};
